import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { ColumnData } from '../interface/interface';
import { OrderSummaryIcon } from '../assets/svgImages';
import { Table } from '../components/Table';
import { PaginationState } from '@tanstack/react-table';
import { getAllClinic } from '../service/clinic';
import showToast from '../components/ToastComponent';

const ListClinics = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [clinics, setClincs] = useState([]);
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 50,
  });
  const [totalRecords, setTotalRecords] = useState<number>(0);

  const fetchClinics = async (token: string) => {
    const response = await getAllClinic(
      pagination.pageIndex,
      pagination.pageSize,
      token,
    );
    if (typeof response === 'number') {
      showToast({
        message: 'Unable to fetch Doctors!',
        type: 'error'
      })
      return;
    }
    setClincs(response.data);
    setTotalRecords(response.data.length);
  };

  useEffect(() => {
    if (!user?.access_token) {
      return;
    }
    fetchClinics(user.access_token);
  }, [user?.access_token]);

  const columns: Array<ColumnData> = [
    {
      key: 'name',
      header: () => 'Name',
      isSortable: true,
      cell: (info) => info.getValue(),
    },
    {
      key: 'hospital_provider_number',
      header: () => 'Hospital Provider Number',
      isSortable: true,
      cell: (info) => info.getValue(),
    },

    {
      key: 'hpio',
      header: () => 'HPIO',
      isSortable: true,
      cell: (info) => info.getValue(),
    },
    {
      key: 'edit',
      header: () => 'View Profile',
      cell: (info) => (
        <button
          type="button"
          className=""
          onClick={() => navigate(`/clinic/${info.row.original.id}`)}
        >
          <OrderSummaryIcon />
        </button>
      ),
    },
  ];

  return (
    <>
      <div className="flex justify-between items-center mb-5">
        <h1 className="text-xl font-semibold leading-6 text-primary-blue-500">
          Clinics
        </h1>
        <Link to={'/clinic/'}>
          <button
            type="button"
            className="ml-2 block rounded-md bg-secondary-cornflowerblue-600 
            px-10 py-3 text-center text-sm font-semibold text-white flex items-center"
          >
            🏥
            <span className="ml-3">Add New Clinic</span>
          </button>
        </Link>
      </div>
      <Table
        columns={columns}
        data={clinics}
        enablePagination={true}
        pagintation={{ state: pagination, setter: setPagination, totalRecords }}
      />
    </>
  );
};

export default ListClinics;
